export function objectFromEntries<Value, Key extends string>(
  array: Array<[Key, Value]>,
) {
  return Object.fromEntries(array) as Record<Key, Value>;
}
